<template>
  <span fluid>
    <v-card class="card--flex-toolbar">
      <v-card-title class="blue-grey lighten-5">
        <h2>Plano de Contas</h2>
        <v-spacer></v-spacer>
        <v-btn @click="onNewButtonClick()" small color="primary">Novo</v-btn>
      </v-card-title>
      <v-card-text>
        <e-data-table
          :headers="headers"
          :items="planos"
          :total="total"
          :hideSearch="true"
          @refresh="getAll"
          @edit="editItem"
          @delete="deleteItem"
        ></e-data-table>
      </v-card-text>
      <v-card-actions></v-card-actions>
    </v-card>
  </span>
</template>
<script>
import planoService from '@/services/plano'
import EDataTable from '@/components/EDataTable'
import { showError, showConfirm, retPermissao } from '@/utils'

export default {
  name: 'plano',
  components: {
    EDataTable
  },
  data () {
    return {
      planos: [],
      total: 0,
      headers: [
        { text: 'Descricao', value: 'descricao', sortable: false },
        { text: 'Tipo', value: 'tipo', sortable: false },
        { text: 'Valor', value: 'valor', sortable: false },
        { text: 'Receita/Despesa', value: 'receita_despesa', sortable: false }],
      valid: true,
      rules: {
        nome: [v => !!v || 'Campo Requerido'],
        ativo: [v => !!v || 'Campo Requerido']
      },
      buttonSaveLoadingVisible: false
    }
  },

  methods: {
    async getAll (page, search) {
      try {
        const result = search === '' ? await planoService.getAll(page) : await planoService.getByNome(search, page)
        this.total = result._meta.total_items
        this.planos = result.data
      } catch (error) {
        this.planos = []
        showError(error)
      }
    },
    editItem (item) {
      var ret = retPermissao('Plano', 'alterar')
      if (ret === true) {
        this.$router.push(`/plano/editar/${item.id}`)
      }
    },
    async deleteItem (item) {
      var ret = retPermissao('Plano', 'excluir')
      if (ret === true) {
        showConfirm(`Tem certeza que deseja remover conta ?`, async result => {
          if (result) {
            try {
              this.loading = true
              await planoService.delete(item.id)
              this.getAll(1, '')
            } catch (error) {
              showError(error)
            } finally {
              this.loading = false
            }
          }
        })
      }
    },
    onNewButtonClick () {
      var ret = retPermissao('Plano', 'incluir')
      if (ret === true) {
        this.$router.push(`/plano/criar`)
      }
    }
  }
}
</script>
